import React, { useState } from 'react';
import { Check } from 'lucide-react';

export default function EmbedPopup({ mapId, mapName, onClose }) {
  const site = window.location.origin;
  const embedBase = `${site}/embed/map/${mapId}`;
  const directLink = `${site}/map/${mapId}`;
  const sizes = [
    { label: 'Medium', width: 900, height: 600 },
    { label: 'Large', width: 1200, height: 800 }
  ];
  const [iframeSize, setIframeSize] = useState(sizes[0]);
  const [copiedType, setCopiedType] = useState("");

  function copyToClipboard(text, typeLabel) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text)
        .then(() => {
          setCopiedType(typeLabel);
          setTimeout(() => setCopiedType(""), 1200);
        })
        .catch(() => {
          fallbackCopy(text, typeLabel);
        });
    } else {
      fallbackCopy(text, typeLabel);
    }
  }
  function fallbackCopy(text, typeLabel) {
    try {
      const tempInput = document.createElement("input");
      tempInput.value = text;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
      setCopiedType(typeLabel);
      setTimeout(() => setCopiedType(""), 1200);
    } catch (err) {
      alert("Failed to copy to clipboard.");
    }
  }

  return (
    <div
      style={{
        position: "absolute",
        right: 28,
        bottom: 90,
        zIndex: 2222,
        background: "#24262d",
        borderRadius: 14,
        boxShadow: "0 2px 18px #0009",
        padding: "26px 32px 20px 24px",
        color: "#fff",
        minWidth: 350,
        maxWidth: 410,
        border: "2px solid #363849"
      }}
    >
      <button
        onClick={onClose}
        style={{
          position: "absolute", top: 12, right: 12, background: "none", border: "none",
          fontSize: 26, color: "#ffe670", cursor: "pointer"
        }}
        title="Close"
      >×</button>
      <div style={{ marginBottom: 16, fontWeight: 700, fontSize: 18, color: "#ffe670" }}>
        Embed this map
      </div>
      <div style={{ fontSize: 15, color: "#f2eec8", marginBottom: 7 }}>
        Share or embed <b>{mapName}</b> on your website or forum.
      </div>
      <label style={{ fontWeight: 700, marginBottom: 5, display: 'block', marginTop: 8 }}>Iframe:</label>
      <div style={{ marginBottom: 6, fontSize: 13 }}>
        Size:{" "}
        {sizes.map(s => (
          <button
            key={s.label}
            onClick={() => setIframeSize(s)}
            style={{
              background: s.label === iframeSize.label ? "#ffe670" : "#23242a",
              color: s.label === iframeSize.label ? "#23242a" : "#ffe670",
              border: "none",
              borderRadius: 7,
              marginRight: 5,
              fontWeight: 700,
              padding: "3px 15px",
              cursor: "pointer"
            }}
          >
            {s.label}
          </button>
        ))}
      </div>
      <div style={{ position: 'relative', marginBottom: 13 }}>
        <input
          style={{
            width: "100%",
            fontSize: 13,
            padding: "7px 12px",
            borderRadius: 8,
            border: "1px solid #393b49",
            background: "#23252b",
            color: "#fff",
            fontFamily: "monospace",
            marginBottom: 3
          }}
          readOnly
          value={`<iframe src="${embedBase}" width="${iframeSize.width}" height="${iframeSize.height}" frameborder="0" style="border-radius:10px;border:1.5px solid #222" allowfullscreen></iframe>`}
          onFocus={e => e.target.select()}
        />
        <button
          onClick={() =>
            copyToClipboard(
              `<iframe src="${embedBase}" width="${iframeSize.width}" height="${iframeSize.height}" frameborder="0" style="border-radius:10px;border:1.5px solid #222" allowfullscreen></iframe>`,
              "iframe"
            )
          }
          style={{
            position: "absolute", right: 7, top: 7,
            background: "#ffe670", color: "#212", border: "none",
            borderRadius: 5, fontWeight: 700, padding: "3px 9px",
            fontSize: 14, cursor: "pointer"
          }}
        >
          {copiedType === "iframe" ? <Check size={16} /> : "Copy"}
        </button>
      </div>
      <label style={{ fontWeight: 700, marginBottom: 5, display: 'block', marginTop: 11 }}>Direct link:</label>
      <div style={{ position: 'relative' }}>
        <input
          style={{
            width: "100%",
            fontSize: 13,
            padding: "7px 12px",
            borderRadius: 8,
            border: "1px solid #393b49",
            background: "#23252b",
            color: "#fff",
            fontFamily: "monospace"
          }}
          readOnly
          value={directLink}
          onFocus={e => e.target.select()}
        />
        <button
          onClick={() => copyToClipboard(directLink, "direct")}
          style={{
            position: "absolute", right: 7, top: 7,
            background: "#ffe670", color: "#212", border: "none",
            borderRadius: 5, fontWeight: 700, padding: "3px 9px",
            fontSize: 14, cursor: "pointer"
          }}
        >
          {copiedType === "direct" ? <Check size={16} /> : "Copy"}
        </button>
      </div>
    </div>
  );
}
